<h1>Managing your Todos with Claude.ai and Claude Desktop</h1>
<br>You can register MCP servers with <a href="https://claude.ai" target="_blank" rel="noopener">Claude.ai</a>. 
<br>With free account you can register one MCP server and that is completely enough to test things out. 
<br>Navigate to Admin settings > Connectors.
<br>Click "Add custom connector" at the bottom of the section.
<br>Add your connector's remote MCP server URL.
<br>
<br><i>Name: Todoapp
<br>URL: {{ url }}/mcp</i>
<br>Finish configuring your connector by clicking "Add."
<br>
<br>
<video controls  preload="none" poster="/claude-poster.jpg">
  <source src="https://apps1storage.blob.core.windows.net/todo-videos/Claude.mp4" type="video/mp4">
  Your browser does not support the video tag.
</video>